import { BriefcaseMedical, Expand } from "lucide-react";

type CareTypeRow = {
  type: string;
  quantity: number;
  price: string;
};

type EnterpriseDashboardCareTypesProps = {
  title: string;
  subtitle?: string;
  viewAllLabel?: string;
  columns: {
    type: string;
    quantity: string;
    price: string;
  };
  rows: CareTypeRow[];
};

export function EnterpriseDashboardCareTypes({
  title,
  subtitle,
  viewAllLabel,
  columns,
  rows,
}: EnterpriseDashboardCareTypesProps) {
  return (
    <div className="theme-card flex h-full cursor-pointer flex-col p-5">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-2">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/15 text-primary">
            <BriefcaseMedical size={20} strokeWidth={2} />
          </div>
          <div className="min-w-0">
            <h3 className="text-sm font-semibold text-foreground">{title}</h3>
            {subtitle ? (
              <p className="mt-0.5 text-xs text-muted">{subtitle}</p>
            ) : null}
          </div>
        </div>
        {viewAllLabel ? (
          <button
            type="button"
            className="inline-flex cursor-pointer items-center gap-1 text-xs font-medium text-primary hover:text-primary/80"
          >
            {viewAllLabel}
            <Expand size={13} />
          </button>
        ) : null}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[320px]">
          <thead>
            <tr className="border-b border-border">
              <th className="px-2 py-2 text-left text-[11px] font-semibold uppercase tracking-wide text-muted">
                {columns.type}
              </th>
              <th className="px-2 py-2 text-right text-[11px] font-semibold uppercase tracking-wide text-muted">
                {columns.quantity}
              </th>
              <th className="px-2 py-2 text-right text-[11px] font-semibold uppercase tracking-wide text-muted">
                {columns.price}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.type} className="border-b border-border last:border-0">
                <td className="px-2 py-2.5 text-sm text-foreground">{row.type}</td>
                <td className="px-2 py-2.5 text-right text-sm text-foreground">{row.quantity}</td>
                <td className="px-2 py-2.5 text-right text-sm text-foreground">{row.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
